import React from 'react';
import { useSelector } from 'react-redux';
import MessengerInbox from '../components/MessengerInbox';
import MessengerThread from '../components/MessengerThread';
import GeeVeeAssistantThread from '../components/GeeVeeAssistantThread';
import useMessengerPolling from '../hooks/useMessengerPolling';

// `heightOffsetRem` accounts for whatever chrome sits above this component in
// the viewport — the default (8.5rem) matches the standalone /messenger route
// (just the app header). When embedded as a tab inside another page (e.g. the
// Communications Hub, which adds its own header + tab bar above this), pass a
// larger offset so the panel doesn't overflow the viewport.
const MessengerPage = ({ heightOffsetRem = 8.5 }) => {
  const { tab, activeSessionId } = useSelector((s) => s.messenger);
  const currentUserId = useSelector((s) => s.auth.user?.id);

  useMessengerPolling({ tab, activeSessionId, currentUserId });

  return (
    <div
      className="flex lg:grid rounded-lg overflow-hidden border border-gray-200 bg-white lg:grid-cols-[280px_1fr] min-h-0"
      style={{
        // Use dvh (dynamic viewport height) so the container hugs the VISIBLE
        // viewport. With plain vh the box extends behind the mobile browser's
        // bottom toolbar, hiding the composer under it.
        height: `calc(100dvh - ${heightOffsetRem}rem)`,
        minHeight: '500px',
      }}
    >
      <div
        className={`${activeSessionId ? 'hidden lg:flex' : 'flex'} flex-col flex-1 lg:flex-none min-w-0 min-h-0 h-full overflow-hidden`}
      >
        <MessengerInbox />
      </div>
      <div
        className={`${activeSessionId ? 'flex' : 'hidden lg:flex'} flex-col flex-1 min-w-0 min-h-0 h-full overflow-hidden`}
      >
        {activeSessionId === 'geevee' ? (
          <GeeVeeAssistantThread />
        ) : (
          <MessengerThread currentUserId={currentUserId} />
        )}
      </div>
    </div>
  );
};

export default MessengerPage;
